import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI } from '../../API';

export const bulkOrderDetailsSlice = createSlice({
    name: 'bulkOrderDetails',
    initialState: {
        shipmentData: {
            data: [],
            meta: { total: 0, current_page: 1, last_page: 1 },
            loading: false,
            notification: { show: false, messageContent: [], messageType: "success" }
        }
    },
    reducers: {
        getBulkShipmentsStart: (state) => {
            state.shipmentData.loading = true;
        },
        getBulkShipmentsSuccess: (state, action) => {
            state.shipmentData.loading = false;
            state.shipmentData.data = action.payload?.data || [];
            state.shipmentData.meta = {
                total: action.payload?.total || 0,
                current_page: action.payload?.current_page || 1,
                last_page: action.payload?.last_page || 1
            };
        },
        getBulkShipmentsFailure: (state, action) => {
            state.shipmentData.loading = false;
            state.shipmentData.notification = {
                show: true,
                messageContent: [action.payload || "Failed to load bulk data"],
                messageType: "error"
            };
        },
        resetBulkOrderNotifications: (state) => {
            state.shipmentData.notification = { show: false, messageContent: [], messageType: "success" };
        }
    }
});

export const { 
    getBulkShipmentsStart, 
    getBulkShipmentsSuccess, 
    getBulkShipmentsFailure, 
    resetBulkOrderNotifications 
} = bulkOrderDetailsSlice.actions;

export const fetchBulkOrderShipments = (params) => dispatch => {
    dispatch(getBulkShipmentsStart());
    
    const queryParams = new URLSearchParams({
        userid: params.userid,
        bulk_reference_id: params.bulk_reference_id,
        type: params.type || 'all', // append type filtering metric context
        page: params.page || 1,
        per_page: params.per_page || 10,
        sorting: params.sorting || ''
    }).toString();

    LABELGENAPI.get(`/bulk-shipments/bulk-orders-details?${queryParams}`)
        .then((response) => {
            if (response.data && response.data.status === 'success') {
                dispatch(getBulkShipmentsSuccess(response.data.data));
            } else {
                dispatch(getBulkShipmentsFailure(response.data?.message));
            }
        })
        .catch((error) => {
            dispatch(getBulkShipmentsFailure(error.response?.data?.message || "Network error"));
        });
};

export default bulkOrderDetailsSlice.reducer;